<template>
	<section id="template-session">
		<ws_header></ws_header>
        <sidebar class="sidebar m-0"></sidebar>

        <section class="content-session">
            <slot></slot>    
        </section>
	</section>


    <!-- <section id="template-session" class="container-fluid border border-danger p-0 m-0">

		<div class="header">
			<ws_header></ws_header>
		</div>

		<sidebar class="sidebar m-0"></sidebar>

		<div class="main">
			<slot></slot>
		</div>
	</section> -->
</template>

<script setup>
	import Sidebar from '../components/Sidebar.vue'
	import ws_header from '../components/Header.vue'
</script>


<style lang="scss" scoped>
    // @import 'ASSETS/scss/minxin.scss';

    #template-session {
        // border: 2px solid red;
        min-height: 100dvh;
        box-shadow: rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset;

        .content-session {
        	position: absolute;
            top: 0px;
            margin-top: 74px;
            margin-left: 130px;
            width: calc(100% - 130px);
            height: calc(100vh - 74px);
            overflow-y: scroll;
            padding: 12px;
        }
    }
</style>